/**
 * This function filters donation options based on the specified platform. So as to not submit irrelevant donation options as "True" when the user is yet to select that platform type. 
 * @param {*} donationOptions 
 * @param {*} platform 
 * @returns 
 */
export function filterDonationOptionsForPlatform(donationOptions = {}, platform) {
    const PLATFORM_KEYS = {
        chatgpt: [
            "ChatGPTConversations",
            "ChatGPTsharedConversations",
            "ChatGPTMessagefeedback",
            "ChatGPTUploadedImages",
        ],
        gemini: [
            "GeminiConversations",
            "GoogleSearchActivity",
            "GoogleAIMode",
            "GeminiUploadedFiles",
        ],
        claude: [
            "ClaudeConversations", 
            "ClaudeProjects",
        ],
        deepseek: [
            "DeepSeekConversations",
        ], 
        mistral: [
            "MistralConversations",
            "MistralUploadedFiles",
        ], 
        grok: [
            "GrokConversations",
            "GrokProjects",
            "GrokTasks",
            "GrokMediaPosts",
        ],
        
    };

    const keys = PLATFORM_KEYS[platform] || [];
    const filtered = {};
    for (const k of keys) {
    if (donationOptions[k] === true) filtered[k] = true;
    }
    return filtered;
}
